export const governorates = '/governorates';
